import axios from "axios";
import { hostServer } from "./consts/host";
import { history } from "../routers/AppRouter";
import { changeFetchInProg } from "./fetchInProgress";

export const getPlans = plans => ({
  type: "GET_PLANS",
  plans
});

export const getSubscriptions = subscriptions => ({
  type: "GET_SUBSCRIPTIONS",
  subscriptions
});

export const startGettingSubscriptions = () => {
  return async (dispatch, getState) => {
    dispatch(changeFetchInProg(true));
    try {
      const header = {
        headers: {
          Authorization: `Token ${getState().auth.uid}`
        }
      };
      const { data } = await axios.get(
        `${hostServer}/api/v1/users/subscriptions`,
        header
      );
      dispatch(getSubscriptions(data));
    } catch (e) {}
    dispatch(changeFetchInProg(false));
  };
};

export const startGettingPlans = () => {
  return async (dispatch, getState) => {
    dispatch(changeFetchInProg(true));
    try {
      const header = {
        headers: {
          Authorization: `Token ${getState().auth.uid}`
        }
      };
      const { data } = await axios.get(
        `${hostServer}/api/v2/users/subscription_plans`,
        header
      );
      dispatch(getPlans(data));
    } catch (e) {}
    dispatch(changeFetchInProg(false));
  };
};

export const startBuyingPlan = (plan_name, period) => {
  return async (dispatch, getState) => {
    dispatch(changeFetchInProg(true));
    try {
      const header = {
        headers: {
          Authorization: `Token ${getState().auth.uid}`
        }
      };
      const data = {
        plan_name,
        period
      };
      await axios.post(
        `${hostServer}/api/v2/users/subscriptions/buy`,
        data,
        header
      );
      history.push(
        `/buy_plan_res?status=OK&plan_name=${plan_name}&goal=buy_plan&period=${period}`
      );
    } catch (e) {}
    dispatch(changeFetchInProg(false));
  };
};
